module.exports = __webpack_public_path__ + "static/media/icon-search.f1607afa.svg";